import React, { Component } from 'react';
import {
  Button, Typography, Icon, Dialog, DialogContent, IconButton,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import AdvancedIcon from '../../assets/img/advanced_icon.svg';
import { advancedProductDialogStyles } from '../../css/style';
import Dropdown from './Dropdown';
import ToolTip from './ToolTip';
import { resourceFields } from '../../data/Constants';
import * as Functions from '../../utils/Functions';

const styles = advancedProductDialogStyles();

class AdvancedProductDialog extends Component {
  constructor(props) {
    super(props);
    const {
      fieldValues, resources, resourceId, setDefaultState, isDefault,
    } = this.props;
    const state = {};
    state.isWidthChanged = false;
    const dropdownOptions = this.getDropdownOptions();
    const staticDropdownFields = ['component', 'customizationView', 'widthPercentage'];
    if (resourceId !== undefined || isDefault === false) {
      const product = resources.products.filter(product => Number(product.id) === Number(resourceId))[0];
      const advancedFields = resourceFields.products.filter(field => field.advanced === true);
      advancedFields.forEach((field) => {
        if (dropdownOptions[field.key] !== undefined && fieldValues[field.key] !== null && fieldValues[field.key] !== undefined) {
          if (staticDropdownFields.includes(field.key)) {
            state[field.key] = dropdownOptions[field.key].filter(option => option.value === fieldValues[field.key])[0];
          } else if (field.key === 'productTax' && dropdownOptions[field.key].length > 0) {
            state[field.key] = dropdownOptions[field.key].filter(option => option.name === fieldValues[field.key].name)[0];
          } else if (Array.isArray(fieldValues[field.key])) {
            state[field.key] = fieldValues[field.key];
          }
        }

        if (field.key === 'widthPercentage' && product) {
          state.initialWidth = product[field.key];
        }
      });
    } else {
      const defaultState = setDefaultState();
      staticDropdownFields.forEach((field) => {
        if (dropdownOptions[field] !== undefined && defaultState[field] !== null) {
          state[field] = dropdownOptions[field].filter(option => option.value === defaultState[field])[0];
        }
      });
      state.isDefault = false;
    }
    this.state = state;
  }

  componentDidUpdate = async (prevProps) => {
    if (prevProps !== this.props) {
      const { fieldValues, resources, resourceId } = this.props;
      const dropdownOptions = this.getDropdownOptions();
      const staticDropdownFields = ['component', 'customizationView', 'widthPercentage'];
      if (resourceId !== undefined && resources !== undefined && resources.products !== undefined) {
        const advancedFields = resourceFields.products.filter(field => field.advanced === true);
        advancedFields.forEach((field) => {
          if (dropdownOptions[field.key] !== undefined) {
            if (staticDropdownFields.includes(field.key)) {
              this.setState({
                [field.key]: dropdownOptions[field.key].filter(option => option.value === fieldValues[field.key])[0],
              });
            } else if (Array.isArray(fieldValues[field.key])) {
              this.setState({
                [field.key]: fieldValues[field.key],
              });
            } else if (field.key === 'productTax') {
              this.setState({
                [field.key]: dropdownOptions[field.key].filter(option => option.name === fieldValues[field.key].name)[0],
              });
            }
          }
        });
      }
    }
  }

  getDropdownOptions = () => {
    const { resources } = this.props;
    const fields = resourceFields.products;
    const staticDropdownFields = ['component', 'customizationView', 'widthPercentage'];
    const dynamicDropdownFields = ['locations', 'productTax'];
    let dropdownOptions = {};
    fields.filter(field => field.advanced === true).map((field) => {
      if (staticDropdownFields.includes(field.key)) {
        dropdownOptions[field.key] = field.options;
      } else if (dynamicDropdownFields.includes(field.key)) {
        dropdownOptions[field.key] = resources[field.dataTable];
      }
    });
    return dropdownOptions;
  }

  onChangeSelectedOption = (event, field, dropdownOptions) => {
    const selectedOption = Functions.getSelectedOptions(event, dropdownOptions, field.allowMultiple);
    this.setState({ [field.key]: selectedOption });
    if (field.key === 'widthPercentage') {
      this.setIsWidthChanged(selectedOption.value);
    }
  }

  onChangeTextField = (event, field) => {
    this.setState({ [field.key]: event.target.value });
  }

  setIsWidthChanged = (currentWidth) => {
    if (this.state.initialWidth !== currentWidth) {
      this.setState({ isWidthChanged: true });
    } else {
      this.setState({ isWidthChanged: false });
    }
  }

  shouldDisableDropdown = (field, dropdownOptions) => (
    (field.key === 'locations' && Array.isArray(dropdownOptions.locations) && dropdownOptions.locations.length <= 1)
    || !Array.isArray(dropdownOptions[field.key])
  )

  isWidthPercentageFieldAndHasChanged = (key, resourceId) => (key === 'widthPercentage' && this.state.isWidthChanged && !!resourceId)

  dropdownStyles = (key, resourceId) => (this.isWidthPercentageFieldAndHasChanged(key, resourceId) ? styles.errorDropdown : styles.dialogDropdown)

  dropdownData = key => (!!this.state && !!this.state[key] ? this.state[key] : [])

  render() {
    const {
      isDialogOpen,
      onOpenAndCloseDialog,
      onClickSaveButton,
      resources,
      resourceId,
      actions,
      apiToken,
      loading,
    } = this.props;

    const fields = resourceFields.products;
    const dropdownOptions = this.getDropdownOptions();

    return (
      <Dialog
        maxWidth="xl"
        open={isDialogOpen}
        onClose={() => onOpenAndCloseDialog()}
      >
        <DialogContent style={styles.advancedProductDialogContainer}>
          <IconButton
            style={styles.closeButton}
            onClick={() => onOpenAndCloseDialog()}
          >
            <Icon>close</Icon>
          </IconButton>
          <img
            src={AdvancedIcon}
            alt="Advanced_Icon"
            style={styles.dialogImage}
          />
          <Typography style={styles.dialogTitle}>
            ADVANCED OPTIONS
          </Typography>
          <div style={styles.fieldsContainer}>
            {fields.filter(field => field.advanced === true).map((field) => {
              if (field.key === 'locations' && !Array.isArray(this.state[field.key]) && this.state[field.key] !== undefined) {
                let locationsArray = [];
                locationsArray.push(this.state[field.key]);
                this.setState({ locations: locationsArray });
              }
              return (
                <div key={field.key} style={styles.fieldContainer}>
                  <div style={styles.fieldTitleContainer}>
                    <Typography style={styles.fieldTitle}>{`${field.title}:`}</Typography>
                    <ToolTip resources={resources} field={field} />
                  </div>
                  <Dropdown
                    style={this.dropdownStyles(field.key, resourceId)}
                    data={this.dropdownData(field.key)}
                    dropdownOptions={dropdownOptions[field.key]}
                    dropdownType={field.dataTable}
                    onChange={event => this.onChangeSelectedOption(event, field, dropdownOptions[field.key])}
                    allowMultiple={field.allowMultiple}
                    actions={actions}
                    apiToken={apiToken}
                    loading={loading}
                    disabled={this.shouldDisableDropdown(field, dropdownOptions)}
                  />
                  {this.isWidthPercentageFieldAndHasChanged(field.key, resourceId)
                    && (
                      <Typography style={styles.errorMessage}>
                        WARNING: changing the width percentage could cause your app to crash.
                    </Typography>
                    )
                  }
                </div>
              );
            })}
          </div>
          <Button
            style={styles.saveButton}
            onClick={() => onClickSaveButton(this.state)}
          >
            SAVE
          </Button>
        </DialogContent>
      </Dialog>
    );
  }
}


AdvancedProductDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  onOpenAndCloseDialog: PropTypes.func.isRequired,
  onClickSaveButton: PropTypes.func.isRequired,
  setDefaultState: PropTypes.func.isRequired,
  resources: PropTypes.objectOf(PropTypes.any).isRequired,
  resourceId: PropTypes.string,
  fieldValues: PropTypes.objectOf(PropTypes.any),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};

AdvancedProductDialog.defaultProps = {
  isDialogOpen: false,
};

export default AdvancedProductDialog;
